export default __webpack_public_path__ + "static/media/mic.85264f1b.svg";